<template>
  <div>
    <div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="审批人">
          <el-input
            v-model="formInline.user"
            placeholder="审批人"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动区域">
          <el-select
            v-model="formInline.region"
            placeholder="活动区域"
          >
            <el-option
              label="区域一"
              value="shanghai"
            ></el-option>
            <el-option
              label="区域二"
              value="beijing"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
          >查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <h1 class="text-center h1">{{$tc('message.video.info[0].title')}}</h1>
    <p class="text-center text-p">{{$tc('message.video.info[0].desc')}}</p>
    <div class="text-center div-video">
      <video
        class="video"
        controls="controls"
      >
        <source
          :src="$tc('message.video.info[0].source1')"
          type="video/ogg"
        >
        <source
          :src="$tc('message.video.info[0].source2')"
          type="video/mp4"
        >
      </video>
    </div>

    <h1 class="text-center h1">{{$tc('message.video.info[1].title')}}</h1>
    <p class="text-center text-p">{{$tc('message.video.info[1].desc')}}</p>
    <div class="text-center div-video">
      <video
        class="video"
        controls="controls"
      >
        <source
          :src="$tc('message.video.info[1].source1')"
          type="video/ogg"
        >
        <source
          :src="$tc('message.video.info[1].source2')"
          type="video/mp4"
        >
      </video>
    </div>

    <p class="text-center text-p">零成本学习如何更快捷、效率的管理工场</p>
  </div>
</template>

<script>
export default {
  name: "HomeContentTeaching",
  data() {
    return {
      formInline: {
        user: "",
        region: "",
      },
    };
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>

<style lang="stylus" scoped>
.h1 {
  padding-top: 5rem;
  color: #333333;
  font-size: 1.9rem;
  line-height: 0.9rem;
  letter-spacing: 0rem;
}

.text-p {
  padding-top: 2rem;
  font-size: 0.9rem;
  line-height: 1.3rem;
  letter-spacing: 0rem;
  color: #666666;
}

.video {
  width: 37.5rem;
  height: 21.6rem;
  background-color: #020000;
}
</style>



// WEBPACK FOOTER //
// src/pages/video/components/ContentTeaching.vue